<div *ngIf="product" class="product-image-cell">

  <div class="image-container font-5">
    <app-image-container
      [image]="imageUrl"
      type="small-product"
      featurePosition='featured-bottom'
      class="clickable"
      [recommended]="isProductRecommended"
      [featured]="product.isFeatured"
      (click)="onImageClicked()"></app-image-container>
  </div>
  <div class="font-5">
    <app-product-item-number [itemNumber]="product.skus[0].getDisplaySkuID()"
                             [supplierId]="product.skus[0].supplierId"></app-product-item-number>
  </div>


</div>
